"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const WalletPassthroughProvider_1 = require("src/contexts/WalletPassthroughProvider");
const useBalances_1 = require("src/hooks/useBalances");
const CoinBalance = (props) => {
    const { data: balances } = (0, useBalances_1.useBalances)();
    const { connected } = (0, WalletPassthroughProvider_1.useWalletPassThrough)();
    const formattedBalance = React.useMemo(() => {
        if (!balances) {
            return '0';
        }
        const accBalanceObj = balances[props.mintAddress];
        if (!accBalanceObj)
            return '0';
        const balance = accBalanceObj.uiAmount.toString();
        return balance;
    }, [balances, props.mintAddress]);
    if (props.hideZeroBalance && (formattedBalance === '0' || !formattedBalance))
        return null;
    if (!connected)
        return null;
    return (0, jsx_runtime_1.jsx)("span", { translate: "no", children: formattedBalance });
};
exports.default = CoinBalance;
